// extracted by mini-css-extract-plugin
module.exports = {"timer-span":"Timer_timer-span__1YP_F","holder":"Timer_holder__3Ejyf"};